import { createContext, useReducer, useEffect, useState } from "react";
import { getCartKey } from "../utils/identifiers";
import { loadCartFromStorage, saveCartToStorage } from "../utils/storage";
import { claimDeviceCartStorageForUser } from "../services/cartOwnership.service";

export const CartContext = createContext();

const initialState = [];

function cartReducer(state, action) {
  switch (action.type) {
    case "INIT_CART":
      return action.payload;

    case "ADD_ITEM": {
      const existing = state.find(
        (item) => item.ProductId === action.payload.ProductId
      );
      if (existing) {
        return state.map((item) =>
          item.ProductId === action.payload.ProductId
            ? {
                ...item,
                Quantity: item.Quantity + action.payload.Quantity,
                Total: (item.Quantity + action.payload.Quantity) * item.Price,
              }
            : item
        );
      }
      return [
        ...state,
        {
          ...action.payload,
          Total: action.payload.Price * action.payload.Quantity,
        },
      ];
    }

    case "UPDATE_ITEM":
      return state.map((item) =>
        item.ProductId === action.payload.ProductId
          ? {
              ...item,
              ...action.payload.updates,
              Total:
                (action.payload.updates.Quantity ?? item.Quantity) * item.Price,
            }
          : item
      );

    case "REMOVE_ITEM":
      return state.filter(
        (item) => item.ProductId !== action.payload.ProductId
      );

    case "EMPTY_CART":
      return [];

    default:
      return state;
  }
}

export function CartProvider({ children, userId }) {
  const cartKey = getCartKey(userId);
  const [cart, dispatch] = useReducer(cartReducer, initialState);
  const [hydratedKey, setHydratedKey] = useState(null);

  useEffect(() => {
    const nextCart = userId
      ? claimDeviceCartStorageForUser(userId).mergedCart
      : loadCartFromStorage(cartKey);

    dispatch({ type: "INIT_CART", payload: nextCart || [] });
    setHydratedKey(cartKey);
  }, [cartKey, userId]);

  useEffect(() => {
    if (hydratedKey !== cartKey) return;
    saveCartToStorage(cartKey, cart);
  }, [cart, cartKey, hydratedKey]);

  return (
    <CartContext.Provider value={{ cart, dispatch }}>
      {children}
    </CartContext.Provider>
  );
}
